import { frontendURL } from '../../../helper/URLHelper';

const BillingIndexPage = () => import('./pages/BillingIndex.vue');
const BillingPayerProfilePage = () => import('./pages/BillingPayerProfile.vue');
const BillingExternalRedirectPage = () =>
  import('./pages/BillingExternalRedirect.vue');
const billingMode = (window.chatwootConfig?.billingMode || 'embedded')
  .toLowerCase()
  .trim();
const isBillingEnabled = ['embedded', 'external'].includes(billingMode);
const billingPortalComponent =
  billingMode === 'external' ? BillingExternalRedirectPage : BillingIndexPage;

const meta = {
  permissions: ['administrator'],
};

const billingBaseRoute = {
  path: frontendURL('accounts/:accountId/billing'),
  name: 'billing_portal_index',
  component: billingPortalComponent,
  meta,
};

const embeddedBillingRoutes = [
  billingBaseRoute,
  {
    path: frontendURL('accounts/:accountId/billing/payer-profile'),
    name: 'billing_payer_profile',
    component: BillingPayerProfilePage,
    meta,
  },
];

const externalBillingRoutes = [billingBaseRoute];

let routes = [];
if (isBillingEnabled) {
  routes =
    billingMode === 'embedded' ? embeddedBillingRoutes : externalBillingRoutes;
}

export { routes };
